import * as types from "./actionTypes.js";
import * as detailedScheduleApi from '../../api/detailedScheduleApi.js';

/**
 *
 */
export function fetchDetailedSchedules(
  startDate,
  endDate,
  resourceId, 
  userId
) {
  return function (dispatch) {
    return detailedScheduleApi
      .getDetailedSchedule(
        startDate,
        endDate,
        resourceId, 
        userId
      )
      .then(detailedSchedules => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_DETAILED_SCHEDULES_SUCCESS,
          detailedSchedules
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function updateDetailedScheduleParameters(parameters) {
  return function (dispatch) {
    dispatch({
      type: types.EDIT_DETAILED_SCHEDULE_PARAMETERS_SUCCESS,
      parameters
    });
  }
}